// KAMPSPORT KIDS READY™ (Norge) — Norwegian (bokmål) copy of MARTIAL ARTS KIDS CLASS READY™ (the winner), translated from the Dutch copy
// (which is the German copy, which is the English v3 that sells). Same structure, palette and angles. Norway, informal "du".
// All copy and links live here. Image URLs live in data/images.ts, the pixel in data/pixel.ts.
// Promise (must match ads, checkout and the PDF): 52-week plan + 10 complete 45-minute kids classes,
// 269 kr one-time, 10-day guarantee, the 5 bonuses in the checkout order.
// Values = the checkout (Markets, NOK): main 1 599 kr; bonuses 349, 269, 269, 269, 349 kr (1 505 kr); total 3 104 kr -> 269 kr, you save 2 835 kr.
// Terms follow productos/martial-arts-kids-no/glosario.md. Class, game, drill, quarter and page names match the
// Norwegian Gamma prompt (prompts/martial-arts-kids-class-ready-no.md, names in productos/martial-arts-kids-no/nombres-libro.md).
// Kids + contact sport: no promises about self-defense, belts or sign-ups; mitts and air only, no sparring; no testimonials.
// ­ = soft hyphen, so long Norwegian words can break on a 375 px screen.   keeps "269 kr" on one line.

export { META_PIXEL_ID } from './pixel';
export const CHECKOUT_URL = 'https://kampsport-kids-norge.impultienda.ar/checkout';

export const PAGE_TITLE = 'Kampsport Kids Ready™ – Hele året med barnetreninger, ferdig planlagt';
export const META_DESCRIPTION =
  'En 52-ukersplan pluss 10 komplette barnetreninger på 45 minutter, klare til bruk. Slå opp ukens side, forbered deg på 5 minutter og kjør økten allerede i dag.';

// GLOBAL
export const brand = 'KAMPSPORT KIDS READY™';
/** Label for every button that scrolls to the offer section */
export const ctaLabel = 'PLANLEGG HELE ÅRET MITT';
export const ctaMicrocopy = 'Rett i innboksen som PDF · 269 kr én gang · 10 dagers garanti';
export const stickyLabel = 'PLANLEGG ÅRET · 269 KR';
export const topBarMobileLabel = 'BOKEN · 269 KR';
export const price = '269 kr';

// 1. HERO (buyer line, title, short subtitle, mockup, button)
export const hero = {
  eyebrow: 'FOR TRENERE I KARATE, TAEKWONDO, KICKBOKSING OG THAIBOKSING',
  titleLead: 'HELE ÅRET MED BARNE­TRENINGER,',
  titleHighlight: 'FERDIG PLANLAGT.',
  sub: 'En 52-ukersplan pluss 10 komplette barnetreninger på 45 minutter, klare til bruk. Slå opp ukens side og kjør økten allerede i dag.',
  mockupAlt: 'Kampsport Kids Ready™ på en dataskjerm, med de 5 bonusene på nettbrett og mobiler',
};

// 2. STATS
export const stats = [
  { value: '52', label: 'UKER PLANLAGT' },
  { value: '10', label: 'KOMPLETTE ØKTER' },
  { value: '45', label: 'MINUTTER MED TIDSPLAN' },
  { value: '3', label: 'ALDERSNIVÅER I HVER ØKT' },
];

// 2b. BEFORE / AFTER
export const beforeAfter = {
  title: 'KVELDEN FØR VS. PÅ MATTEN.',
  before: {
    label: 'FØR',
    when: 'Kvelden før',
    quote: '«Hva skal jeg gjøre med barna i kveld?»',
    items: ['Leter etter øvelser i videoklipp.', 'Den samme slagøvelsen igjen.', 'De minste faller av, de eldste kjeder seg.'],
  },
  after: {
    label: 'ETTER',
    when: 'På matten',
    items: ['Slå opp ukens side.', 'Forbered deg på 5 minutter.', 'Kjør økten på 45 minutter.', 'Hils ut og send foreldreinfoen.'],
  },
};

// 3. WHAT DOES YOUR CLASS NEED THIS WEEK (pick a need, see the class that is ready for it)
const block = 'Øktblokk: hilsing & oppvarmingslek 8 · teknikk 12 · mitts- & partnerøvelser 12 · avslutningslek 8 · nedtrapping & verdiprat 5';
export const selector = {
  eyebrow: 'BEGYNN DER BARNA DINE ER NÅ',
  title: 'HVA TRENGER ØKTEN DIN DENNE UKEN?',
  sub: 'Velg et tema og se økten som allerede er klar for det.',
  startLabel: 'DIN NESTE ØKT',
  tablistLabel: 'Tema for øktene',
  columns: ['SIDE 1 · ØKTPLAN', 'SIDE 2 · SLIK FORKLARER DU DET', 'SIDE 3 · ØVELSER & LEK'],
  note: 'Alle de 10 øktene har samme oppbygging på 3 sider. Tilpass hver økt til din stil og sikkerhetsreglene i din dojo.',
  items: [
    {
      tab: 'En sterk start: holdning & respekt',
      n: 'ØKT 01 · UKE 1',
      title: 'Holdning, gard & respekt i dojoen',
      goal: 'Barnet hilser, står i en stabil kampstilling med garden høyt og går tilbake til klarstilling på kommando.',
      open: ['Øktmål, utstyr og forberedelse på 5 minutter', 'Dine åpningsord: «Føttene fra hverandre, én fot bakover. Hendene høyt ved ansiktet. Det er garden din!»', block],
      activity: ['5 teknikksteg med de viktige punktene: inntak, hilsen, klarstilling, kampstilling, gard', '3 kort «Slik retter du det», som «Togskinner, ikke line!»', 'Kort for aldersnivå: slik fungerer det med 4–6, 7–9 og 10–12 år'],
      close: ['2 øvelser med matteskisse: Stillingssjekk og Sprett & frys', 'Avslutningslek: Dojoen befaler', 'Verdiprat (Respekt), foreldreinfo og stripegradering'],
    },
    {
      tab: 'Spark med balanse',
      n: 'ØKT 03 · UKE 9',
      title: 'Frontspark & balanse',
      goal: 'Barnet løfter kneet, sparker fremover med fotballen og setter foten kontrollert ned i stillingen.',
      open: ['Øktmål, utstyr og forberedelse på 5 minutter', 'Dine åpningsord: «Kneet opp … spark … kneet tilbake … foten ned. Garden blir oppe!»', block],
      activity: ['Teknikksteg med de viktige punktene, fra kneet opp til foten ned', '3 kort «Slik retter du det» for de vanligste feilene i sparket', 'Kort for aldersnivå for 4–6, 7–9 og 10–12 år'],
      close: ['2 øvelser på sparkeputen, med matteskisse og tider', 'Avslutningslek: Trafikklyset', 'Verdiprat (Selvkontroll), foreldreinfo og stripegradering'],
    },
    {
      tab: 'Kombinasjoner på mittsene',
      n: 'ØKT 06 · UKE 22',
      title: 'Slag­kombinasjoner på mittsene',
      goal: 'Barnet slår en kombinasjon på 3 (jab, cross, krok) på mittsene og går tilbake i garden.',
      open: ['Øktmål, utstyr og forberedelse på 5 minutter', 'Dine åpningsord: «1 er jab, 2 er cross, 3 er krok. Klar? 1-2-3 … gard!»', block],
      activity: ['Teknikksteg for kroken og 1-2-3', 'Slik holder de eldste mittsene trygt for en partner', 'Kort for aldersnivå for 4–6, 7–9 og 10–12 år'],
      close: ['2 mittsøvelser med matteskisse, runder og tider', 'Avslutningslek: Kombinasjonskjeden', 'Verdiprat (Samarbeid), foreldreinfo og stripegradering'],
    },
    {
      tab: 'Sikkerhet & frigjøring fra grep',
      n: 'ØKT 09 · UKE 35',
      title: 'Frigjøring fra grep & trygg med fremmede',
      goal: 'Barnet frigjør seg fra et mykt grep rundt håndleddet, tar et steg bakover, bruker en sterk stemme og vet at det etterpå skal løpe til en voksen det stoler på og fortelle hva som skjedde.',
      open: ['Øktmål, utstyr og forberedelse på 5 minutter', 'Dine åpningsord: vri løs, steg bakover, sterk stemme, løp til en voksen du stoler på', block],
      activity: ['Enkle frigjøringssteg, øvd sakte og mykt', 'Sikkerhetsreglene: bli i gruppen, bruk stemmen, fortell det til en voksen du stoler på', 'Kort for aldersnivå for 4–6, 7–9 og 10–12 år'],
      close: ['2 rolige øvelser med matteskisse', 'Avslutningslek: Stafett med sterk stemme', 'Verdiprat (Sikkerhet), foreldreinfo og stripegradering'],
    },
  ],
};

// 4. LOOK INSIDE (real pages of the book, in the same order as pageImages in data/images.ts)
export const lookInside = {
  eyebrow: 'EKTE SIDER. SE OPPSETTET FØR DU KJØPER.',
  title: 'DETTE LIGGER VED SIDEN AV MATTEN DIN FRA NÅ AV.',
  sub: 'Åpne hver side i full størrelse: 52-ukersplanen din, en øktplan, forklaringen og øvelsene til en økt, generalprøven før beltegraderingen og øktplanleggeren din.',
  hint: 'Sveip for mer · Trykk på en side for å se den stor',
  note: 'Dette er utvalgte sider, ikke hele boken.',
  captions: [
    'Din 52-ukersplan (kvartal 3)',
    'Økt 05 · Øktplan',
    'Økt 02 · Slik forklarer du det',
    'Økt 02 · Øvelser & lek',
    'Økt 10 · Generalprøve før beltegraderingen',
    'Øktplanlegger + stripeoversikt',
  ],
};

// 5. THE SYSTEM
export const plan = {
  eyebrow: 'ETT SYSTEM FOR HVER ØKT',
  title: 'HELE ÅRET ER PLANLAGT. DU HILSER OG KJØRER ØKTEN.',
  text: 'Hver uke i året er planlagt: starten på en av de 10 komplette øktene, en ferdig lek eller øvelse på 10 minutter, eller en stripegradering. Hver økt gir deg på 3 sider øktplanen, teknikkstegene og øvelsene med lek.',
  steps: [
    { title: 'SLÅ OPP', text: 'Finn denne uken i 52-ukersplanen din.' },
    { title: 'FOR­BERED', text: 'Les siden og gjør matten klar på 5 minutter.' },
    { title: 'KJØR ØKTEN', text: 'Oppvarmingslek, én teknikk, mitts og partnere.' },
    { title: 'HILS UT', text: 'Avslutningslek, verdiprat og foreldreinfoen.' },
  ],
  featuresTitle: 'I HVER KOMPLETTE ØKT',
  features: [
    { icon: 'goal', title: 'Ett tydelig øktmål', text: 'Én setning om hva barna skal gjøre, startuken og hvilke forkunnskaper de trenger.' },
    { icon: 'timer', title: 'En øktblokk på 45 minutter', text: 'Hilsing & oppvarmingslek 8 · Teknikk 12 · Mitts- & partnerøvelser 12 · Avslutningslek 8 · Nedtrapping & verdiprat 5.' },
    { icon: 'steps', title: 'Teknikksteg + instrukser', text: 'Nummererte steg med de viktige punktene, og nøyaktig den instruksen som retter de vanligste feilene.' },
    { icon: 'questions', title: '4–6, 7–9 og 10–12 år', text: 'Slik gir du den samme økten til alle aldre på matten din, også i blandede grupper.' },
    { icon: 'quote', title: 'Ordene dine, ordrett', text: 'Åpningsord, kommandoer og verdipraten, pluss et profftips og en vanlig feil.' },
    { icon: 'action', title: 'Øvelser, lek + foreldreinfo', text: '2 øvelser og en avslutningslek med matteskisse, en stripegradering og foreldreinfo som kan sendes med en gang.' },
  ],
} as const;

// 5b. VALUES + AGE LEVELS
export const valuesBand = {
  eyebrow: 'MER ENN SPARK OG SLAG',
  title: 'EN VERDI FOR HVER ØKT. HELE ÅRET.',
  sub: 'Hver økt avsluttes med en kort verdiprat, skrevet ut ordrett, så foreldrene ser hva barna tar med seg hjem.',
  classWord: 'ØKT',
  values: [
    { n: '01', value: 'Respekt' },
    { n: '02', value: 'Konsen­trasjon' },
    { n: '03', value: 'Selv­kontroll' },
    { n: '04', value: 'Utholden­het' },
    { n: '05', value: 'Selv­tillit' },
    { n: '06', value: 'Sam­arbeid' },
    { n: '07', value: 'Opp­merksomhet' },
    { n: '08', value: 'Mot' },
    { n: '09', value: 'Sikkerhet' },
    { n: '10', value: 'Disiplin' },
  ],
  agesTitle: 'HVER ØKT TILPASSES BARNA FORAN DEG',
  ages: [
    { age: '4–6 ÅR', text: 'Gulvmarkeringer, dyrenavn, korte steg de sier høyt sammen med deg, og mange leker.' },
    { age: '7–9 ÅR', text: 'Hele teknikken på trenerens mitts, og bytte side på kommando.' },
    { age: '10–12 ÅR', text: 'Høyere tempo, bevege seg med garden oppe, holde mittsene for en partner og hjelpe til med å lede økten.' },
  ],
};

// 6. THE 52-WEEK PLAN (quarter names as printed in the book)
export const yearPlan = {
  eyebrow: 'DIN 52-UKERSPLAN',
  title: 'HELE ÅRET, PLANLAGT UKE FOR UKE.',
  sub: 'I ★-ukene starter en ny økt. ◆-ukene er stripegraderinger. I ukene imellom venter en ferdig lek eller øvelse på 10 minutter.',
  weekWord: 'UKE',
  quarters: [
    {
      q: 'K1',
      weeks: 'UKE 1–13',
      name: 'LEGG GRUNNLAGET',
      full: [
        { week: '1', label: 'START ØKT 01', title: 'Holdning, gard & respekt i dojoen' },
        { week: '5', label: 'START ØKT 02', title: 'Rette slag: jab & cross' },
        { week: '9', label: 'START ØKT 03', title: 'Frontspark & balanse' },
        { week: '13', label: 'STRIPEGRADERING', title: 'Sjekk fremgangen med øktplanleggeren', review: true },
      ],
      activities: '+ ferdige leker og øvelser på 10 minutter, som Statue i gard, Oppstilling mot klokken og Stå som en flamingo.',
    },
    {
      q: 'K2',
      weeks: 'UKE 14–26',
      name: 'TREFF & FORSVAR',
      full: [
        { week: '14', label: 'START ØKT 04', title: 'Rundspark' },
        { week: '18', label: 'START ØKT 05', title: 'Blokker: høy, middels & lav' },
        { week: '22', label: 'START ØKT 06', title: 'Slag­kombinasjoner på mittsene' },
        { week: '26', label: 'STRIPEGRADERING', title: 'Sjekk fremgangen med øktplanleggeren', review: true },
      ],
      activities: '+ ferdige leker og øvelser på 10 minutter, som Dreieklokken, Regnblokk og Rop kombinasjonen.',
    },
    {
      q: 'K3',
      weeks: 'UKE 27–39',
      name: 'BEVEG DEG & VÆR TRYGG',
      full: [
        { week: '27', label: 'START ØKT 07', title: 'Fotarbeid & avstand' },
        { week: '31', label: 'START ØKT 08', title: 'Trygge fall' },
        { week: '35', label: 'START ØKT 09', title: 'Frigjøring fra grep & trygg med fremmede' },
        { week: '39', label: 'STRIPEGRADERING', title: 'Sjekk fremgangen med øktplanleggeren', review: true },
      ],
      activities: '+ ferdige leker og øvelser på 10 minutter, som «For nær, for langt unna», Gyngestolen og Trygg sone.',
    },
    {
      q: 'K4',
      weeks: 'UKE 40–52',
      name: 'SETT ALT SAMMEN',
      full: [
        { week: '40', label: 'START ØKT 10', title: 'Generalprøve før beltegraderingen' },
        { week: '52', label: 'STRIPEGRADERING', title: 'Stripegradering ved slutten av året', review: true },
      ],
      activities: '+ ferdige leker og øvelser på 10 minutter, som Blokkmesteren, Opp på scenen og Dojostafetten.',
    },
  ],
  toolsTitle: 'PLUSS VERKTØYET DITT SOM TRENER',
  tools: ['Når økten blir vanskelig: 8 situasjoner, hva du sier og hva du gjør', 'Øktplanlegger + stripeoversikt: planlegg hver økt på 5 minutter', 'Jukselapp til å ha ved siden av matten'],
};

// 7. THE 10 COMPLETE CLASSES
export const meetings = {
  eyebrow: 'DE 10 KOMPLETTE ØKTENE',
  title: 'TI BARNETRENINGER. KLARE TIL BRUK.',
  sub: 'Følg 52-ukersplanen eller begynn med økten barna dine trenger nå. Hver økt har 3 sider: øktplan, slik forklarer du det, øvelser & lek.',
  weekLabel: 'STARTUKE',
  items: [
    { n: '01', week: '1', title: 'Holdning, gard & respekt i dojoen', goal: 'Hilse, en stabil kampstilling med garden høyt og klarstilling på kommando.' },
    { n: '02', week: '5', title: 'Rette slag: jab & cross', goal: 'Jab og cross fra garden, med hånden tilbake ved ansiktet hver gang.' },
    { n: '03', week: '9', title: 'Frontspark & balanse', goal: 'Kneet opp, spark med fotballen og land kontrollert i stillingen.' },
    { n: '04', week: '14', title: 'Rundspark', goal: 'Vri standfoten, kneet opp til siden og spark kontrollert mot et lavt eller middels høyt mål.' },
    { n: '05', week: '18', title: 'Blokker: høy, middels & lav', goal: 'Tre blokker på kommando, med blikket på treneren.' },
    { n: '06', week: '22', title: 'Slag­kombinasjoner på mittsene', goal: 'En kombinasjon på 3 slag (jab, cross, krok) på mittsene og tilbake i garden.' },
    { n: '07', week: '27', title: 'Fotarbeid & avstand', goal: 'Bevege seg fremover, bakover og til siden uten å krysse føttene, og finne riktig avstand.' },
    { n: '08', week: '31', title: 'Trygge fall', goal: 'Falle bakover og til siden fra en lav stilling, haken mot brystet, og reise seg trygt.' },
    { n: '09', week: '35', title: 'Frigjøring fra grep & trygg med fremmede', goal: 'Frigjøre seg fra et mykt grep rundt håndleddet, bruke den sterke stemmen og løpe til en voksen man stoler på.' },
    { n: '10', week: '40', title: 'Generalprøve før beltegraderingen', goal: 'En rolig prøvegradering med årets teknikker, et vurderingsskjema og teksten til seremonien.' },
  ],
  cta: 'FÅ ALLE 10 ØKTENE + 5 BONUSER',
  ctaMicrocopy: '269 kr · Engangsbetaling',
};

// 8. BONUSES (same order and values as the checkout)
export const bonuses = {
  eyebrow: '5 BONUSER INKLUDERT I BOKEN TIL 269 KR',
  title: 'ALT ANNET BARNETRENINGENE DINE TRENGER.',
  sub: 'Leker, beltegraderinger, meldinger til foreldre, mittsøvelser og en plan for prøvetreningen, klare til bruk.',
  valueWord: 'VERDI',
  free: 'GRATIS',
  coverWord: 'Omslag',
  totalNote: '1 505 kr i bonuser, gratis med på kjøpet',
  items: [
    {
      label: 'BONUS 01',
      value: '349 kr',
      short: '60 kampsportleker for barn',
      hook: 'Aldri mer tom for lekeideer.',
      title: '60 kampsport­leker for barn – helt uten utstyr',
      text: '60 morsomme, trygge leker til å åpne hver økt, få ut energi og avslutte, sortert etter mål: oppvarming, reaksjon, balanse, konsentrasjon, spark og slag, samarbeid og nedtrapping. Hver med oppsett, regler, varighet og et sikkerhetstips.',
    },
    {
      label: 'BONUS 02',
      value: '269 kr',
      short: 'Graderingssettet',
      hook: 'Rolige, godt organiserte graderinger.',
      title: 'Graderingssettet – krav, graderingsplan & diplomer til utskrift',
      text: 'En eksempelsjekkliste med kravene for hvert belte (tilpasses din stil), et vurderingsskjema, en graderingsplan med tider, hva du sier ved åpningen og avslutningen, en stripeoversikt og diplomer til utskrift.',
    },
    {
      label: 'BONUS 03',
      value: '269 kr',
      short: 'Foreldrepakken',
      hook: 'Du vet nøyaktig hva du sender til familiene.',
      title: 'Foreldre­pakken – velkomstbrev, dojoregler & ferdige meldinger',
      text: 'Et velkomstbrev til nye barn, dojoregler for barn på én side, en sjekkliste «Hva tar jeg med?», kunngjøringer for beltegraderinger, en månedlig melding om månedens verdi, meldinger ved fravær og veiledninger for rolige samtaler med foreldre.',
    },
    {
      label: 'BONUS 04',
      value: '269 kr',
      short: '50 mitts- & partnerøvelser',
      hook: 'Nytt arbeid på mittsene i hver økt.',
      title: '50 mitts- & partner­øvelser – til hver barnetrening',
      text: '50 øvelser med mitts, sparkeputer og partnere for slag, spark, blokker, kombinasjoner, fotarbeid og reaksjon. Hver med oppsett, runder og tider, hvordan du holder mittsene og et sikkerhetstips.',
    },
    {
      label: 'BONUS 05',
      value: '349 kr',
      short: 'Prøvetreningsguiden',
      hook: 'Så hver første økt teller.',
      title: 'Prøvetrenings­guiden – en første trening barn og foreldre husker',
      text: 'Hvordan du tar imot familien i døren, en prøvetrening på 30 minutter med leker og en første teknikk som alle barn klarer, hva du sier på slutten og ferdige meldinger til dagene etterpå.',
    },
  ],
};

// 9. OFFER
export const offer = {
  eyebrow: 'DIN NESTE ØKT BEGYNNER HER',
  title: 'HELE ÅRET MED BARNETRENINGER. I ÉN BOK.',
  kicker: 'DEN KOMPLETTE DIGITALE BOKEN',
  name: 'Kampsport Kids Ready™',
  description: 'En 52-ukersplan og 10 komplette barnetreninger på 45 minutter, klare til bruk, pluss fem bonuser: leker, et graderingssett, meldinger til foreldre, mittsøvelser og en guide til prøvetreningen.',
  mockupAlt: 'Alt som er med i Kampsport Kids Ready™',
  includedTitle: 'BOKEN DIN INNEHOLDER',
  included: [
    '52-ukersplan: hele året planlagt',
    '10 komplette barnetreninger på 3 sider hver',
    'En øktblokk på 45 minutter med tider i hver økt',
    'Teknikksteg, viktige punkter og instrukser ved feil',
    '4–6, 7–9 og 10–12 år i hver økt',
    'Øvelser, avslutningslek, verdiprat og foreldreinfo',
    'Verktøy som trener: vanskelige øyeblikk, øktplanlegger, jukselapp',
  ],
  /** Value stack: exactly the checkout prices (NOK) */
  stackTitle: 'DETTE FÅR DU',
  mainItem: { label: 'Kampsport Kids Ready™ (52-ukersplan + 10 komplette økter)', value: '1 599 kr' },
  totalLabel: 'Total verdi',
  totalValue: '3 104 kr',
  todayLabel: 'I DAG',
  priceNote: 'Engangsbetaling · Rundt 5 kroner i uken',
  saveNote: 'Du sparer 2 835 kr',
  /** The ONLY button that goes to checkout */
  cta: 'JA, SEND MEG BOKEN – 269 KR',
  ctaNote: ['Videre til sikker betaling', 'Tilgang på e-post etter betalingen'],
  format: 'PDF på norsk. Digital levering. Tilpass hver økt til din stil, sikkerhetsreglene i din dojo og alderen og nivået til barna dine.',
  guaranteeNote: '10 dagers fornøyd-eller-pengene-tilbake-garanti',
};

// 10. GUARANTEE
export const guarantee = {
  sealTop: '10',
  sealBottom: 'DAGER PENGENE TILBAKE',
  title: '10 DAGER. IKKE FORNØYD? PENGENE TILBAKE. INGEN SPØRSMÅL.',
  text: 'Kjør de neste øktene dine med den. Er det likevel ikke noe for deg? Send en e-post til support@stockdigital.shop innen 10 dager etter kjøpet, så får du pengene tilbake.',
};

// 11. FAQ
export const faq = {
  eyebrow: 'DU VET NØYAKTIG HVA DU FÅR',
  title: 'NOEN SPØRSMÅL FØR DU GÅR UT PÅ MATTEN.',
  sub: 'Laget for trenere og eiere av kampsportklubber som trener barn. En ferdig øktbok, ikke et videokurs.',
  items: [
    {
      q: 'Hva er dette produktet egentlig?',
      a: 'En PDF-bok på norsk: en 52-ukersplan (hver uke har starten på en økt, en ferdig lek eller øvelse på 10 minutter, eller en stripegradering) og 10 komplette barnetreninger på 45 minutter med 3 sider hver, pluss verktøyet ditt som trener og 5 bonuser.',
    },
    {
      q: 'Hvilke stilarter passer den til?',
      a: 'Til stilarter med slag og spark som læres bort til barn: karate, taekwondo, kickboksing, thaiboksing og blandede programmer. Teknikkene har generelle navn (frontspark, jab, høy blokk), og hver økt minner deg på å bruke navnene, etiketten og belterekkefølgen i din stilart.',
    },
    {
      q: 'Hvilken alder er den for?',
      a: 'For barn fra omtrent 4 til 12 år. Hver økt har et kort for aldersnivå for 4–6, 7–9 og 10–12 år, så den fungerer også i blandede grupper.',
    },
    {
      q: 'Blir det sparring eller kontakt?',
      a: 'Det blir ingen sparring. Barna slår og sparker på mitts, mål og i luften. Partnerøvelser kun med lett, kontrollert kontakt på mittsene og alltid under oppsyn. Fall øves bare på matter, fra en lav stilling.',
    },
    {
      q: 'Lærer barna selvforsvar i sikkerhetsøkten?',
      a: 'Økt 09 lærer enkle, myke frigjøringer fra grep og sikkerhetsregler: bli i gruppen, bruke en sterk stemme og fortelle det til en voksen man stoler på. Det er ikke et løfte om at et barn kan forsvare seg i enhver situasjon.',
    },
    {
      q: 'Hvordan får jeg den?',
      a: 'Etter betalingen får du tilgang på e-postadressen du skriver inn i kassen. Ingenting sendes i posten. Bruk en e-postadresse du har tilgang til, og se i søppelposten om nødvendig.',
    },
    {
      q: 'Kan jeg bruke øktene hver for seg?',
      a: 'Ja. Hver økt fungerer for seg selv: du kan begynne med økten barna dine trenger nå, eller følge 52-ukersplanen fra uke 1.',
    },
    {
      q: 'Kan jeg skrive den ut?',
      a: 'Ja. Sidene er lette å lese på mobilen eller nettbrettet ved siden av matten, og øktplanleggeren og stripeoversikten er klare til utskrift.',
    },
    {
      q: 'Kan jeg dele den med trenerne mine?',
      a: 'Dette kjøpet er til ditt eget bruk som trener. Deling med flere klubber, spredning eller videresalg er ikke med i dette tilbudet.',
    },
    { q: 'Er det et abonnement?', a: 'Nei. Du betaler 269 kr én gang.' },
    { q: 'Hvordan fungerer garantien?', a: 'Du har 10 dager på deg til å be om pengene tilbake, uten noe styr.' },
  ],
};

// 12. FINAL CTA
export const finalCta = {
  eyebrow: 'TIL NESTE GANG DU TENKER «HVA SKAL JEG GJØRE MED BARNA I KVELD?»',
  title: 'GÅ UT PÅ MATTEN I DAG MED EN FERDIG ØKT.',
  text: 'Slå opp ukens side. Forbered deg på 5 minutter. Kjør en økt barna gleder seg til å komme tilbake til.',
  microcopy: '52-ukersplan + 10 komplette økter + 5 bonuser · 269 kr, engangsbetaling',
};

// 13. FOOTER
export const footer = {
  line: 'KAMPSPORT KIDS READY™ · Øktmateriell for trenere. Følg alltid reglene i din stilart og sikkerhetsreglene i din dojo.',
  supportLabel: 'Kundeservice:',
  supportEmail: 'support@stockdigital.shop',
  copyright: '© 2026',
};
